module.exports = __webpack_public_path__ + "static/media/col1row1.ab28c3fe.jpg";